'use client';

import Script from 'next/script';
import { type PropsWithChildren, useEffect, useState } from 'react';

import { getPaymentsLibUrl } from '@/helpers/conf';
import { configPaymentsLib } from '../ExternalMainScripts/helpers';

export const ExternalScripts = ({ children }: PropsWithChildren) => {
  const [paymentsLibUrl, setPaymentsLibUrl] = useState('');

  useEffect(() => {
    setPaymentsLibUrl(getPaymentsLibUrl(window.location.hostname));
  }, []);

  return (
    <>
      {children}
      {paymentsLibUrl && (
        <Script
          onError={(e) => console.error('Payments script failed', e)}
          onLoad={configPaymentsLib}
          src={paymentsLibUrl}
          strategy="afterInteractive"
        />
      )}
    </>
  );
};
